import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Paths from "../../../constants/paths";

type ClientsIdHeaderProps = {
  companyName: string;
};

export const ClientsIdHeader = ({ companyName }: ClientsIdHeaderProps) => {
  const { t } = useTranslation("boClients");
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-col gap-8">
        <div className="flex flex-row items-center gap-2">
          <button
            className="text-medium align-middle text-sm text-gray-600"
            onClick={() => navigate(Paths.bo.clients)}
          >
            {t("clientPage.breadcrumbClients")}
          </button>
          <span className="align-middle text-[#CBD5E1]">{`>`}</span>
          <h4 className="text-semibold align-middle text-sm text-[#06F]">{companyName}</h4>
        </div>
      </div>
      <h1 className="font-jakarta-sans text-3xl font-semibold">{companyName}</h1>
    </div>
  );
};
